import { io } from 'socket.io-client'

/* eslint-disable */

export function useNats() {

  console.log('natssssssssss')
  const socket = io("http://localhost:3300/events", {
    transports: ["websocket", "polling"],
  });

  // socket.on("connect", () => {
  //   console.log("Connesso!");
  // });

  const publish = (subject, payload) => {
    socket.emit('cmd:publish', { subject, payload })
  };

  socket.on('mqtt.event', (data) => {
    console.log('Evento MQTT:', data)
  })

  const subscribe = (baseDb, topic) => {
    console.log('ohhhh')
    socket.emit('cmd:subscribe', { baseDb, topic })
  }

  return { publish, socket, subscribe }
}
